import { Component, EventEmitter, OnInit, Output, Input, forwardRef, ViewChild } from '@angular/core';
import { Course, Scene, Annotation, AnnotationType } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControlDirective, ControlContainer } from '@angular/forms';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'annotation-selector',
  templateUrl: './annotation-selector.component.html',
  styles: [
    `
    mat-form-field{
        width: 100%;
      }

    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AnnotationSelectorComponent,
      multi: true
    }
  ]
})
export class AnnotationSelectorComponent implements OnInit, ControlValueAccessor {
  @Input() isDynamic: boolean;
  @Input() course: Course;
  @Input() scene: Scene;
  annotations: Annotation[];
  select: FormGroup;
  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  @Input()
  formControl: FormControl;
  @Input()
  showNext : boolean;
  @Input()
  formControlName: string;

  constructor(
    private _courseApiService: CoursesAPIService,
    private controlContainer: ControlContainer
  ) {

  }
  get control() {
    return this.formControl || this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit(): void {
    if(this.isDynamic){
      this._courseApiService.getCourseDynamicAnnotations(this.course.id).subscribe(annotations=>{
        this.annotations = annotations.annotations.filter((annotation) => annotation.type !== AnnotationType.snapZone).sort(this.sortAnnotations);
      })
    }
    else{
      this._courseApiService.getSceneAnnotations(this.scene.id).subscribe(annotations=>{
        this.annotations = annotations.filter((annotation) => annotation.type !== AnnotationType.snapZone).sort(this.sortAnnotations);
      })
    }
  }
  sortAnnotations(annotation1: Annotation, annotation2: Annotation){
    if (annotation1.type > annotation2.type) return 1;
	  if (annotation1.type < annotation2.type) return -1;
    return annotation1.label.localeCompare(annotation2.label);
  }
  registerOnTouched(fn: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.registerOnTouched(fn);
    }
  }

  registerOnChange(fn: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.registerOnChange(fn);
    }
  }

  writeValue(obj: any): void {
    if (this.formControlDirective) {
      this.formControlDirective.valueAccessor.writeValue(obj);
    }
  }

}
